import { today } from 'app/constants/dates';
import { FuelReceiptState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const fuelReceiptState: FuelReceiptState = {
  vehicle: null,
  fuelType: null,
  dateRange: {
    fromDate: today.minDay.startOf('day').toUTC().toISO(),
    untilDate: today.minDay.endOf('day').toUTC().toISO(),
  },
  fuelReceipts: [],
  fuelReceiptToEdit: null,
  fuelReceiptToDelete: null,
  fuelReceiptsReportData: [],

  // Sorting
  sortBy: '-last-changed-date',
  sortField: 'last-changed-date',

  limit: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
  totalRecordCount: 0,

  documentType: 'pdf',
  isExportDataRequestPending: false,

  isVehicleFilterMenuClosed: true,

  isToggleUploadCsvModal: false,
  isToggleExportFileModal: false,
  isToggleDeleteFuelReceiptModal: false,
  isToggleCreateEditFuelReceiptModal: false,
  isToggleFuelReceiptBulkDownloadModal: false,
};
